<template>
  <div v-if="isShowBtn">
    <transition name="addScreen">
      <!-- <div v-if="isShowBtn && showTimes < defaultShowTimes" @click="showGuide" class="add-to-main-screen__mobile heart">{{  $t('add-to-screen')  }}</div> -->
      <!-- <div v-if="isShowBtn" @click="showGuide" class="add-to-main-screen__mobile heart">{{  $t('add-to-screen')  }}</div> -->
    </transition>
    <!-- <div v-if="isShowBtn" class="pwa-prompt-wrap" :class="{ 'active': deferredPrompt }"> -->
    <div class="pwa-prompt-wrap safari active">
      <!-- <span class="text">{{ $t('add_screen_des1') }} {{ $t('add_screen_des2') }}</span> -->
      <a href="javascript:;" class="btn btn-install" @click="showGuide">{{ $t('add-to-screen') }}</a>
    </div>

    <transition name="iosGuide">
      <div v-show="isShowGuide" class="ios-guide" :class="{ active: isShowGuide }" @click="isShowGuide = false">
        <div class="guide-wrap" @click.stop>
          <div class="close" @click="isShowGuide = false"></div>
          <div class="title">{{ $t('ios-guide-1') }}</div>
          <div class="subtitle">{{ $t('ios-guide-2') }} {{ $t('ios-guide-3') }}</div>
          <div class="logo"></div>
          <div class="game">State Of Survival</div>
          <div class="phone"></div>
          <i18n path="ios-guide-4" tag="div" class="txt">
            <div :slot="0" class="up"></div>
          </i18n>
          <i18n path="ios-guide-5" tag="div" class="txt">
            <div :slot="0" class="add"></div>
            <template :slot="1">{{ $t('ios-guide-1') }}</template>
          </i18n>
          <div class="mune">
            <div>{{ $t('ios-guide-1') }}</div>
          </div>
          <div class="arr"></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'AddIosSafariBtn',
  data () {
    return {
      isShowBtn: false,
      isShowGuide: false,
      showTimes: Number(window.localStorage.getItem('_i_g_times') || 0),
      defaultShowTimes: 3
    }
  },
  created () {
    const ua = window.navigator.userAgent.toLowerCase()
    const isQuickApp = window.navigator.standalone
    var issafariBrowser = (ua.indexOf('applewebkit') > -1 && ua.indexOf('mobile') > -1 && ua.indexOf('safari') > -1 &&
      ua.indexOf('linux') === -1 && ua.indexOf('android') === -1 && ua.indexOf('chrome') === -1 &&
      ua.indexOf('ios') === -1 && ua.indexOf('browser') === -1)
    if (issafariBrowser && this.$utils.isMobile && !isQuickApp) {
      // if (this.showTimes < this.defaultShowTimes) {
      this.isShowBtn = true
      // }
      // window.localStorage.setItem('_i_g_times', this.showTimes + 1)
    }
  },
  computed: {
    showBtn () {
      const ua = window.navigator.userAgent.toLowerCase()
      const isQuickApp = window.navigator.standalone
      var issafariBrowser = (ua.indexOf('applewebkit') > -1 && ua.indexOf('mobile') > -1 && ua.indexOf('safari') > -1 &&
        ua.indexOf('linux') === -1 && ua.indexOf('android') === -1 && ua.indexOf('chrome') === -1 &&
        ua.indexOf('ios') === -1 && ua.indexOf('browser') === -1)
      if (issafariBrowser && this.$utils.isMobile && !isQuickApp) {
        return true
      }
      return issafariBrowser && this.$utils.isMobile && this.showTimes < this.defaultShowTimes && !isQuickApp
    }
  },
  methods: {
    showGuide () {
      this.$gtag.event('click_guide', { event_label: 'safari' })
      // this.showTimes = this.defaultShowTimes
      // window.localStorage.setItem('_i_g_times', this.showTimes)
      this.isShowGuide = true
      this.$utils.log('webgame_shorcut_guide', { type: 'click_icon' })
    }
  }
}
</script>

<style scoped lang="less">
// @use "~@/utils/utils.scss" as utils;

// @include utils.setMobileContent{
// }
.addScreen-enter{
  transform: translateY(-100%);
  opacity: 0;
}
.addScreen-leave-to{
  transform: translateY(100%);
  opacity: 0;
}
.addScreen-enter-active,
.addScreen-leave-active{
  transition: all .3s;
}

.add-to-main-screen__mobile{
  height: 50px;
  top: 10px;
  right: 15px;
  border-radius: 35px;
  font-size: 24px;
  line-height: 50px;
  padding: 0 30px;
  position: fixed;
  background-color: rgba(255, 255, 255, .7);
  cursor: pointer;
  z-index: 100;
}

.ios-guide {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.5);
  transition: all .3s linear;
  text-align: center;
  &.iosGuide-enter{
    .guide-wrap {
      transform: translateY(100%);
    }
  }
  &.iosGuide-leave-to{
    .guide-wrap {
      transform: translateY(100%);
    }
  }
  .guide-wrap {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    background-color: rgba(30, 30, 42, 1);
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 10px 20px;
    transition: all .3s linear;
  }
  .close {
    width: 28px;
    height: 28px;
    position: absolute;
    right: 30px;
    top: 20px;
    background-image: url("~@/assets/img/ss/icon_guide_close.png");
    background-size: 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
  }
  .title {
    font-size: 40px;
    padding: 0 40px;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 56px;
  }
  .subtitle {
    font-size: 28px;
    font-weight: 400;
    color: #A5A5A5;
    line-height: 40px;
    margin-top: 5px;
  }
  .logo {
    background-image: url("~@/assets/img/ss/icon_guide_logo.png");
    background-size: 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
    width: 130px;
    height: 130px;
    margin-top: 10px;
  }
  .game {
    font-size: 30px;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 42px;
  }
  .phone {
    background-image: url("~@/assets/img/ss/icon_guide_phone.png");
    background-size: 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
    width: 240px;
    height: 261px;
    margin-top: -62px;
    margin-bottom: -20px;
  }
  .txt {
    font-size: 32px;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 1;
    margin-top: 10px;
    div {
      display: inline-block;
      vertical-align: middle;
      background-size: 100% 100%;
      background-position: center center;
      background-repeat: no-repeat;
      width: 68px;
      height: 68px;
    }
    .up {
      background-image: url("~@/assets/img/ss/icon_guide_up.png");
    }
    .add {
      background-image: url("~@/assets/img/ss/icon_guide_add.png");
    }
  }
  .mune {
    margin-top: 15px;
    width: 454px;
    height: 226px;
    background-image: url("~@/assets/img/ss/guide_mune.png");
    background-size: 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
    position: relative;
    text-align: left;
    div {
      position: absolute;
      height: 85px;
      line-height: 85px;
      bottom: 0;
      left: 20px;
      right: 80px;
      font-size: 26px;
      color: #585555;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-weight: 600;
    }
  }
  .arr {
    width: 50px;
    height: 50px;
    background-image: url("~@/assets/img/ss/icon_guide_arr.png");
    background-size: 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
    margin-top: 20px;
  }
}
.heart {
  animation: breathe 1s ease-in-out infinite;
}
@keyframes breathe {
  0%{ transform: scale(.98); }
  50%{ transform: scale(1.05); }
  100%{ transform: scale(.98); }
}

.pwa-prompt-wrap{
  height: @headerH;
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #B0B0B0;
  line-height: 22px;
  position: relative;
  left: 50%;
  top: -@headerH;
  opacity: 1;
  transition: all .3s;
  transform: translateX(-50%);
  & > *{
    // margin: 0 15px;
  }
  &.active{
    top: 0;
    opacity: 1;
  }
}
.btn-install{
  max-width: 250px;
  height: 36px;
  padding: 0 12px;
  font-weight: 500;
  color: #331C00;
  line-height: 16px;
  border-radius: 5px;
  background-color: #fff;
  display: flex;
  align-items: center;
}

// 手机
@media screen and (max-width: 768px) {
  .pwa-prompt-wrap{
    height: @m_headerH;
    top: -@m_headerH;
    .text{
      display: none;
    }
    .btn-install{
      height: 40px;
      border-radius: 5px;
      line-height: 18px;
    }
  }
}
</style>
